




















































import {
  Component,
  Emit,
  Vue
} from 'vue-property-decorator';
import CookieCategory from '@/cookie-notice/inputs/CookieCategory.vue';
import CookieCategoryItem from '@/cookie-notice/inputs/CookieCategoryItem.vue';
import MatomoCookieService from '@/services/matomo/MatomoCookieService';
import GoogleCookieService from '@/services/google/GoogleCookieService';

@Component({
  components: {CookieCategoryItem, CookieCategory}
})
export default class CookiePreferences extends Vue {
  private matomoCookieService = MatomoCookieService.singleton();
  private googleCookieService = GoogleCookieService.singleton();

  public isMatomoTrackingAllowed = this.matomoCookieService.isTrackingAllowed();
  public isGoogleAnalyticsAllowed = this.googleCookieService.isTrackingAllowed();

  get isStatisticsCategoryChecked(): boolean {
    return this.isMatomoTrackingAllowed && this.isGoogleAnalyticsAllowed;
  }

  public toggleMatomoTracking() {
    this.isMatomoTrackingAllowed = !this.isMatomoTrackingAllowed;
  }

  public toggleGoogleTracking() {
    this.isGoogleAnalyticsAllowed = !this.isGoogleAnalyticsAllowed;
  }

  public toggleAll() {
    const categoryChecked = this.isStatisticsCategoryChecked;
    this.isMatomoTrackingAllowed = !categoryChecked;
    this.isGoogleAnalyticsAllowed = !categoryChecked;
  }

  public onlySelectedClicked() {
    this.matomoCookieService.setPreference(this.isMatomoTrackingAllowed);
    this.googleCookieService.setPreference(this.isGoogleAnalyticsAllowed);
    this.buttonClicked();
  }

  public acceptAllClicked() {
    this.matomoCookieService.allowTracking();
    this.googleCookieService.allowTracking();
    this.buttonClicked();
  }

  @Emit()
  public buttonClicked() {}

}
